import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/icon_info_line.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-491869be")

_pushScopeId("data-v-491869be")
const _hoisted_1 = { class: "fridgedoormonitor-weekly-item" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "fridgedoormonitor-weekly-item-topspacer" }, null, -1)
const _hoisted_3 = { class: "fridgedoormonitor-weekly-item-grapharea-scale" }
const _hoisted_4 = { class: "fridgedoormonitor-weekly-item-grapharea-scale-y" }
const _hoisted_5 = { class: "fridgedoormonitor-weekly-item-grapharea-scale-y-item" }
const _hoisted_6 = { class: "fridgedoormonitor-weekly-item-grapharea-scale-y-item-text" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "fridgedoormonitor-weekly-item-grapharea-scale-spacer" }, null, -1)
const _hoisted_8 = { class: "fridgedoormonitor-weekly-item-grapharea-scale-xitem-text" }
const _hoisted_9 = { class: "fridgedoormonitor-weekly-item-grapharea-scale-yaxistitle" }
const _hoisted_10 = { class: "fridgedoormonitor-weekly-item-grapharea-scale-yaxistitle-text" }
const _hoisted_11 = { class: "fridgedoormonitor-weekly-item-grapharea-scale-xaxistitle" }
const _hoisted_12 = { class: "fridgedoormonitor-weekly-item-grapharea-scale-xaxistitle-text" }
const _hoisted_13 = { class: "fridgedoormonitor-weekly-item-grapharea-caution" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "fridgedoormonitor-weekly-item-grapharea-caution-spacer" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("img", {
  class: "fridgedoormonitor-weekly-item-grapharea-caution-item-button-image",
  src: _imports_0
}, null, -1)
const _hoisted_16 = { class: "fridgedoormonitor-weekly-item-notice" }
const _hoisted_17 = { class: "fridgedoormonitor-weekly-item-notice-part" }
const _hoisted_18 = /*#__PURE__*/_createVNode("img", {
  class: "fridgedoormonitor-weekly-item-notice-part-image",
  src: _imports_0
}, null, -1)
const _hoisted_19 = { class: "fridgedoormonitor-weekly-item-notice-part-description" }
const _hoisted_20 = { class: "fridgedoormonitor-weekly-item-notice-part-description-text" }
const _hoisted_21 = { class: "fridgedoormonitor-weekly-item-description" }
const _hoisted_22 = { class: "fridgedoormonitor-weekly-item-description-text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", {
      class: "fridgedoormonitor-weekly-item-grapharea",
      style: _ctx.styleGraphArea
    }, [
      _createVNode("canvas", {
        class: "fridgedoormonitor-weekly-item-grapharea-canvas",
        ref: "canvas",
        width: _ctx.canvasSize.width,
        height: _ctx.canvasSize.height
      }, null, 8, ["width", "height"]),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.yAxisScales, (scaleText) => {
            return (_openBlock(), _createBlock("div", { key: scaleText }, [
              _createVNode("div", _hoisted_5, [
                _createVNode("span", _hoisted_6, _toDisplayString(scaleText), 1)
              ])
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _hoisted_7,
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.xAxisScales, (xscaleText) => {
          return (_openBlock(), _createBlock("div", {
            class: "fridgedoormonitor-weekly-item-grapharea-scale-xitem",
            key: xscaleText
          }, [
            _createVNode("span", _hoisted_8, _toDisplayString(xscaleText), 1)
          ]))
        }), 128 /* KEYED_FRAGMENT */)),
        _createVNode("div", _hoisted_9, [
          _createVNode("span", _hoisted_10, _toDisplayString(_ctx.yAxisTitle), 1)
        ]),
        _createVNode("div", _hoisted_11, [
          _createVNode("span", _hoisted_12, _toDisplayString(_ctx.xAxisTitle), 1)
        ])
      ]),
      _createVNode("div", _hoisted_13, [
        _hoisted_14,
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.cautionStyles, (itemStyle) => {
          return (_openBlock(), _createBlock("div", {
            class: "fridgedoormonitor-weekly-item-grapharea-caution-item",
            key: itemStyle.marginTop
          }, [
            (itemStyle.visible)
              ? (_openBlock(), _createBlock("div", {
                  key: 0,
                  class: "fridgedoormonitor-weekly-item-grapharea-caution-item-button",
                  style: { marginTop: itemStyle.marginTop },
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickCaution(...args)))
                }, [
                  _hoisted_15
                ], 4))
              : _createCommentVNode("", true)
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ], 4),
    _createVNode("div", _hoisted_16, [
      _createVNode("div", _hoisted_17, [
        _hoisted_18,
        _createVNode("div", _hoisted_19, [
          _createVNode("span", _hoisted_20, _toDisplayString(_ctx.noticeText), 1)
        ])
      ])
    ]),
    _createVNode("div", _hoisted_21, [
      _createVNode("span", _hoisted_22, _toDisplayString(_ctx.descriptionText), 1)
    ])
  ]))
})